import React, {FC, useEffect, useState} from 'react'
import { useHistory } from 'react-router'

import { TopBarRedesigned } from "components/TopBarRedesigned";
import {exitReact} from "utils";
import {JobProps, PartialOffer} from "utils/types";
import {BasicContainer, NameTitle, Title, TitleContainer, UserContainer} from "./CustomOfferPage.styles";
import dayjs from "dayjs";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import styles from "../../hygienist/ShiftDetailPage/ShiftDetail.module.scss";
import {Value, ValueBox} from "../../hygienist/ConfirmedOfferPage/ConfirmedOffer.styles";
import {Icon} from "../../hygienist/AvailableJobsPage/AvailableJobsPage.styles";
import heartFilled from "../../../images/heartFilled.svg";
import heartUnfilled from "../../../images/heartUnfilled.svg";
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import { OfferTimer } from 'components/OfferTimer';

interface JobWithSelOffer extends JobProps {
    selOffer: PartialOffer
}

const CustomOfferPage: FC<{}> = () => {
    const history = useHistory()
    const {job} = history.location.state as { job: JobWithSelOffer }

    const { hygienist } = job.selOffer

    const goHome = () => {
        history.push('loading')
        exitReact('job-partial', { id: job.id })
    }
    return (
        <>
            <TopBarRedesigned
                onBack={goHome}
                title={'Custom Offer'}
            />
            <BasicContainer>
                <UserContainer>
                    <NameTitle>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <div style={{color: 'var(--primary-blue)'}}>{hygienist.firstName} {hygienist.lastName}</div>
                            <Icon
                                style={{height: 22}}
                                src={job.selOffer.isFavouriteHygienist ? heartFilled : heartUnfilled}
                            />
                        </div>
                        <div style={{color: 'var(--text-secondary)', fontSize: '0.875rem'}}>Graduated: {hygienist.graduationYear} from: {hygienist.school}</div>
                        {hygienist?.isLeftHanded ? 
                            <div style={{color: 'var(--primary-green)', fontWeight: 500}}>{hygienist.firstName} is left-handed</div> 
                            : null}
                        {hygienist.status === 1 ? 
                            <div style={{display: 'flex', alignItems: 'center', color: 'var(--primary-blue)'}}><EmojiEventsOutlinedIcon style={{marginRight: '4px'}}/>Pro</div> 
                            : null}
                        {hygienist.status === 2 ? 
                            <div style={{display: 'flex', alignItems: 'center', color: 'var(--primary-blue)'}}><EmojiEventsOutlinedIcon style={{marginRight: '4px'}}/>Elite</div> 
                            : null}
                        <div style={{color: 'var(--primary-main)', fontWeight: 500, marginTop: '8px'}}>
                            <OfferTimer expiresAt={job.selOffer.expiresAt}/>
                        </div>
                    </NameTitle>
                </UserContainer>

                <TitleContainer>
                    <Title>
                        <div>
                            <div>Dental {job.status ? 'Hygienist' : 'Assistant'} Shift</div>
                            <div>{`${job.location.address},`}</div>
                            <div>{`${job.location.city}, ${job.location.province} ${job.location.postalCode}`}</div>
                        </div>
                        <div>
                            <div style={{display: 'flex', alignItems: 'center', color: 'var(--primary-blue)'}}>
                                <DateRangeOutlinedIcon className={styles.shiftDateIcon} style={{color: 'var(--primary-blue)'}}/>
                                {dayjs(job.shifts[0].shiftDate).format('dddd, MMM D')}
                            </div>
                            <ValueBox>Start at: <Value style={{color: 'var(--primary-blue)'}}>{job.shifts[0].postedStart}</Value></ValueBox>
                            <ValueBox>Shift ends: <Value style={{color: 'var(--primary-blue)'}}>{job.shifts[0].postedEnd}</Value></ValueBox>
                        </div>
                    </Title>
                </TitleContainer>
            </BasicContainer>
        </>
    )
}

export default CustomOfferPage
